/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { newContractConfig } from "./NewContract.formfield.config";
import { getDropdownValue } from "../../../../../../../components/finalForms/libs/data/dropdownUtilities";
import { ServiceLocationContext } from "../../../../../../../utils/context/ServiceLocationContext";
import { setDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { useLazyGetAllClientsQuery } from "../../../../../../../app/services/clientAPI";
import { useAddContractMutation, useLazyGetAllContractInstallmentTypesQuery, useLazyGetAllContractTypeQuery } from "../../../../../../../app/services/contractAPI";
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";
import { getSelectedDropdownObject } from "../../../../../../../utils/formFieldUtils/getDropdownValue";
import ToastService from "../../../../../../../services/toastService/ToastService";

const NewContract = ({ onClose, row }) => {

  const NewContractRef = useRef();

  const [contractForm, setContractForm] = useState(newContractConfig);
  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);

  const [getAllClients, {
    isFetching: isAllClientsFetching,
    isSuccess: isAllClientsFetched,
    data: allClientsData,
  },] = useLazyGetAllClientsQuery();

  const [getAllContractType, {
    isSuccess: isAllContractTypeFetched,
    data: AllContractTypeData
  }] = useLazyGetAllContractTypeQuery();

  const [getAllContractInstallmentTypes, {
    isFetching: isAllContractInstallmentTypesFetching,
    isSuccess: isAllContractInstallmentTypesFetched,
    data: allContractInstallmentTypesData,
  },] = useLazyGetAllContractInstallmentTypesQuery();

  const [addContract, {
    isSuccess: isContractAdded,
    data: ContractData,
  },] = useAddContractMutation();

  useEffect(() => {
    if (locationkey) {
      getAllClients(locationkey);
      getAllContractType(false);
      getAllContractInstallmentTypes(false);
      setFieldSetting(contractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, true);
      setFieldSetting(contractForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, true);
    }
  }, [locationkey])

  useEffect(() => {
    if (!isAllClientsFetching && isAllClientsFetched && allClientsData) {
      setDropdownOptions(allClientsData, 'lClientKey', 'sClientName1', contractForm, 'lClientKey', setContractForm);
      setFieldSetting(contractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllClientsFetching, isAllClientsFetched, allClientsData])

  useEffect(() => {
    if (isAllContractTypeFetched && AllContractTypeData) {
      setDropdownOptions(AllContractTypeData, 'lContractTypeKey', 'sContractType', contractForm, 'lContractTypeKey', setContractForm);
      setFieldSetting(contractForm, 'lContractTypeKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractTypeFetched, AllContractTypeData])

  useEffect(() => {
    if (!isAllContractInstallmentTypesFetching && isAllContractInstallmentTypesFetched && allContractInstallmentTypesData) {
      setDropdownOptions(allContractInstallmentTypesData, 'lInstallmentTypeID', 'sInstallmentType', contractForm, 'lInstallmentTypeID', setContractForm);
      setFieldSetting(contractForm, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractInstallmentTypesFetching, isAllContractInstallmentTypesFetched, allContractInstallmentTypesData])

  useEffect(() => {
    if (isContractAdded && ContractData) {
      if (ContractData?.errorMessage.includes("exists")) {
        ToastService.error(ContractData?.errorMessage);
      }
      else if (ContractData) {
        ToastService.success(ContractData?.errorMessage);
      }
    }
  }, [isContractAdded, ContractData, getAllContractType]);

  const handleSaveClick = () => {
    if (NewContractRef.current) {
      const formData = NewContractRef.current.getFormData();
      if (formData) {
        const contractlength = formData?.contractlength;
        if (!formData) {
          ToastService.error("Please fill all required fields");
          return;
        }
        if (!contractlength || contractlength <= 0) {
          ToastService.warning('Please enter valid Contract Length');
          return;
        }
        if (contractlength && contractlength >= 12) {
          ToastService.warning('Contract Length should be less than 12 months');
          return;
        }

        const formatDate = (date) => {
          if (!date) return null;
          return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0];
        };

        const requestData = {
          plClientKey: getDropdownValue(formData?.lClientKey),
          plContractTypeKey: getDropdownValue(formData?.lContractTypeKey),
          plInstallmentTypeID: getDropdownValue(formData?.lInstallmentTypeID),
          pdtEffectiveDate: formatDate(formData?.dtDateEffective),
          pdtTerminationDate: formatDate(contractForm?.initialState?.Dterminationdate),

          psContractNumber: formData?.PurchaseOrderNumber,
          pnContractTotal: 0,
          pnInvoiceAmount: 0,
          plContractLength: formData?.contractlength,
          plContractKeyBeingRenewed: 0,
          pbCostsPerDepartment: true,
          psContractName: contractForm?.initialState?.contractName,
        };
        addContract(requestData);
      }
    }
  }

  const getOpts = (id) => {
    return (
      contractForm.section[0].fields.find(f => f.id === id)?.fieldSetting?.options || []
    );
  };

  useEffect(() => {
    if (!row) return;
    if (!isAllClientsFetched || !isAllContractTypeFetched) return;

    const clientOpts = getOpts("lClientKey");
    const typeOpts = getOpts("lContractTypeKey");

    if (clientOpts.length === 0 || typeOpts.length === 0) return;

    const clientObj = getSelectedDropdownObject(row.lClientKey, clientOpts);
    const typeObj = getSelectedDropdownObject(row.lContractTypeKey, typeOpts);

    const d = new Date();
    const formattedDate = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;

    setContractForm(prev => ({
      ...prev,
      initialState: {
        ...prev.initialState,
        lClientKey: clientObj,
        lContractTypeKey: typeObj,
        contractName: `${clientObj?.label || ""} ${typeObj?.label || ""} ${formattedDate}`,
        dtDateEffective: row?.dtDateEffective ? new Date(row.dtDateEffective) : null,
      }
    }));
  }, [row, isAllClientsFetched, isAllContractTypeFetched]);


  const getUpdatedContractData = (updatedData) => {
    const fields = contractForm.section[0].fields;
    const clientOpts =
      fields.find(f => f.id === "lClientKey")?.fieldSetting?.options || [];
    const typeOpts =
      fields.find(f => f.id === "lContractTypeKey")?.fieldSetting?.options || [];

    const state = { ...contractForm.initialState, ...updatedData };

    const clientObj = getSelectedDropdownObject(state.lClientKey, clientOpts);
    const typeObj = getSelectedDropdownObject(state.lContractTypeKey, typeOpts);

    const contractName = `${clientObj?.label || ""} ${typeObj?.label || ""}`.trim();

    return { state, clientObj, typeObj, contractName, };
  };

  const updateContractName = (newState) => {
    const { clientObj, typeObj } = getUpdatedContractData(newState);

    const formattedDate = `${newState?.Dterminationdate.getMonth() + 1}/${newState?.Dterminationdate.getDate()}/${newState?.Dterminationdate.getFullYear()}`;

    setContractForm(prev => ({
      ...prev,
      initialState: {
        ...newState,
        lClientKey: clientObj || newState.lClientKey,
        lContractTypeKey: typeObj || newState.lContractTypeKey,
        contractName: `${clientObj?.label || newState.lClientKey?.label} ${typeObj?.label || newState.lContractTypeKey?.label} ${formattedDate}`
      }
    }));
  };

  const addMonths = (date, months) => {
    if (!date) return null;
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    return d;
  };


  const handleFieldChange = (dataField, updatedData) => {
    if (dataField === "contractlength") {
      const months = Number(updatedData.contractlength);
      const effDate = updatedData.dtDateEffective || contractForm.initialState.dtDateEffective;
      const newTermination = addMonths(effDate, months);
      const newState = {
        ...contractForm.initialState,
        ...updatedData,
        Dterminationdate: newTermination,
      };
      setContractForm(prev => ({
        ...prev,
        initialState: newState
      }));
      updateContractName(newState);
      return;
    }
    if (dataField === 'Dterminationdate') {
      const newState = {
        ...contractForm.initialState,
        ...updatedData
      };
      setContractForm(prev => ({
        ...prev,
        initialState: newState
      }));
      updateContractName(newState);
      return;
    }

    if (dataField === 'lClientKey' || dataField === 'lContractTypeKey') {
      updateContractName(updatedData);
    }
  };

  return (
    <>
      <div className="row">
        <FormCreator ref={NewContractRef} config={contractForm} onColumnChange={handleFieldChange} />
        <div className="d-flex justify-content-end gap-3 export-icon">
          <Buttons
            buttonText="Save"
            onClick={handleSaveClick}
            buttonTypeClassName="btn blue-btn"
            titleText="Save"
          />
          <Buttons
            buttonText="Cancel"
            onClick={onClose}
            buttonTypeClassName="btn blue-btn"
            titleText="Cancel"
          />
        </div>
      </div>
    </>
  );
};
export default NewContract;
